import { IconButton, Typography } from "@mui/material";
import { PrimaryTooltip } from "../StyledComponent";
import CustomIcon from "../CustomIcon";
import { getStatusDisplay, ONBOARDING_IN_PROGRESS } from "../../Helper/OperationalStatus/statusOptions";

const OperationalStatusActionBadge = ({status, label, reasonForNonOperational, onClick, readOnly = false}) => {

    let borderColor = '#E6E6E6';
    let hoverBorderColor = '#D4D5FC';
    let color = '#3D4B5A';
    let hoverColor = '#6D72F6'
    let backgroundColor = 'transparent';
    let hoverBackgroundColor = 'transparent';
    let iconColor = '#686868';
    let hoverIconColor = '#6D72F6';
    // The onboarding value's stored display name is lower case; show the standard label.
    let displayLabel = status === ONBOARDING_IN_PROGRESS ? getStatusDisplay(status).label : label;

    if (status === undefined || status === null) {
        borderColor = '#FF7F7A';
        hoverBorderColor = '#FF7F7A';
        color = '#3D4B5A';
        hoverColor = '#3D4B5A'
        backgroundColor = '#FFF1F1';
        hoverBackgroundColor = '#FFE4E4';
        iconColor = '#686868';
        hoverIconColor = '#686868';

        displayLabel = 'Not Set';
    } else if (status === 'non_operational') {
        borderColor = '#FFAA75';
        hoverBorderColor = '#FFAA75';
        color = '#494949';
        hoverColor = '#000000'
        backgroundColor = '#FFF6F0';
        hoverBackgroundColor = '#FFE9DB';
        iconColor = '#494949';
        hoverIconColor = '#000000';

        displayLabel += `: ${reasonForNonOperational}`;
    }

    const truncateText = (text, maxLength = 25) => {
        if (!text) return ''
        if (text.length <= maxLength) return text;
        return text.slice(0, maxLength) + "...";
    }

    return (
        <PrimaryTooltip title={status === 'non_operational' ? displayLabel : ''} position="bottom">
            <IconButton
                aria-label="operational-status"
                onClick={readOnly ? undefined : onClick}
                onMouseDown={() => {}}
                edge="end"
                sx={{
                    border: `1px solid ${borderColor}`,
                    borderRadius: '500px',
                    padding: '2px 12px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: backgroundColor,
                    cursor: readOnly ? 'default' : 'pointer',
                    '& svg path': {
                        fill: iconColor
                    },

                    ...(!readOnly && {
                        '&:hover': {
                            borderColor: hoverBorderColor,
                            backgroundColor: hoverBackgroundColor,

                            '& svg path': {
                                fill: hoverIconColor
                            },
                            '& .MuiTypography-root': {
                                color: hoverColor
                            }
                        }
                    })
                }}
            >
                <CustomIcon name="gear-icon" />
                <Typography variant="fw400s12lh24c3D4B5A" sx={{ml: 0.5, color: color}}>{truncateText(displayLabel)}</Typography>
            </IconButton>
        </PrimaryTooltip>
    )
}

export default OperationalStatusActionBadge;
